import React, { useState, useEffect, useCallback, useContext } from "react";
import { Row, Col, Input, Button, Tooltip, Space, Avatar, Modal, Card } from "antd";
import { ControlsSection, CTAButton, Header, Styled } from "./styled";
import { FiSearch } from "react-icons/fi";
import GroupsGrid from "./groups/Groups";
import { CustomSearchContainer } from "../../../../table-item";
import { StyledTable } from "../../../admin/videos/styled";
import { groupService } from "../../../../../services/Group";
import { debounce, notify } from "../../../../../utils/helper";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddGroupModal from "../../AddGroupModal";
import moment from "moment";
import DeleteConfirmationModal from "../../../physician_page/component/DeleteConfirmationModal";
import { capitalizeFirstLetter } from "../../../../../utils/utils";
import AddPhysicianFormModal from "../../../physician_page/component/AddPhysicianFormModal";
import { PhysicianPageWrapper } from "../../../physician_page/styled";
import Filter from "../../../../table-item/filter/Filter";
import { SpecilityContext } from "../../../../../context/SpecilityContext";
import AssisgnedVideoModal from "../../../admin/videos/AssisgnedVideoModal";


const Overview = ({ isOpen, setIsOpen }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allGroupData, setAllGroupData] = useState([]);
  const [groupCount, setGroupCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageSize: 25,
    current: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isGroupEdit, setIsGroupEdit] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [sortingColumn, setSortingColumn] = useState("");
  const [show, setShow] = useState(false);
  const [filterTab, setFilterTab] = useState([]);
  const { specialtyOptions } = useContext(SpecilityContext);
  const [physicianDetailModal, setPhysicianDetailModal] = useState(false);
  const [physicianData, setPhysicianData] = useState([]);
  const [memberType, setMemberType] = useState("physician");
  const [allGroupSpecialty, setAllGroupSpecialty] = useState([]);

  const GroupColumns = [
    {
      title: "Name",
      dataIndex: "hospitalName",
      width: 250,
      key: "fullName",
      sorter: (a, b) => (a.fullName || "").localeCompare(b.fullName || ""),
      render: (_, record) => (
        <span
          style={{ width: "200px" }}
          className="d-flex justify-start ellipsis"
        >
          {capitalizeFirstLetter(record.hospitalName)}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 200,
      key: "description",
      render: (_, record) => (
        <span
          style={{ width: "200px" }}
          className="d-flex justify-start ellipsis"
        >
          {capitalizeFirstLetter(record.description)}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 100,
      key: "type",
      sorter: (a, b) => (a.type || "").localeCompare(b.type || ""),
      render: (_, record) => (
        <span
          style={{ width: "200px" }}
          className="d-flex justify-start ellipsis"
        >
          {record.type ? (
          capitalizeFirstLetter(record.type)) : ("-")}
        </span>
      ),
    },
    {
      title: "Members",
      dataIndex: "totalPhysician",
      width: 100,
      align: "center",
      key: "totalPhysician",
      render: (_, record) => {
        const physicians = Array.isArray(record.totalPhysician) ? record.totalPhysician : [];
        const coordinators = Array.isArray(record.totalCoordinators) ? record.totalCoordinators : [];
        const members = physicians.length > 0 ? physicians : coordinators;
        if (members.length === 0) return 0;
        return (
          <div
            className="cursor"
            onClick={() => {
              setPhysicianData(members);
              setMemberType(physicians.length > 0 ? "physician" : "coordinator");
              setPhysicianDetailModal(true);
            }}
            style={{ display: "flex", alignItems: "center", gap: 4, justifyContent: "center" }}
          >
            <Avatar.Group maxCount={2} maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
              {members.map((member, idx) => (
                <Avatar key={member.id || idx} style={{ backgroundColor: "var(--border-color)", color: "var(--primary-text-color)" }}>
                  {member.name ? member.name[0] : "?"}
                </Avatar>
              ))}
            </Avatar.Group>
          </div>
        );
      },
    },
    {
      title: "Specialty",
      dataIndex: "specialty",
      width: 180,
      align: "center",
      key: "specialtyName",
      sorter: (a, b) => (a.specialtyName || "").localeCompare(b.specialtyName || ""),
      render: (_, record) => (
        <span
          className="d-flex justify-content-center ellipsis"
        >
          {capitalizeFirstLetter(
            (Array.isArray(record.specialty) ? record.specialty : []).join(", "),
          )}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: 100,
      align: "center",
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (createdAt) => moment(createdAt).format("DD-MMM-YYYY hh:mm A"),
    },
    {
      title: "Actions",
      align: "center",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <div
              onClick={() => {
                setIsGroupEdit(true);
                setSelectedId(record);
                setIsEditOpen(true);
              }}
              className="cursor icon-button-edit"
            >
              <EditOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Delete">
            <div
              onClick={() => {
                setSelectedId(record._id);
                setIsDeleteModalOpen(true);
              }}
              className="cursor icon-button-delete"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const fetchGroups = async (searchInput = searchTerm) => {
    try {
      setLoading(true);
      const response = await groupService.getAll(
        pagination?.pageSize,
        pagination?.current,
        searchInput,
        sortingColumn,
        JSON.stringify(filterTab),
      );
      // console.log("overview data", response);
      setAllGroupData(response?.data?.results);
      setGroupCount(response?.data?.totalResults);
      // console.log("groupData:", response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, [pagination, sortingColumn, filterTab]);

  const handleSearch = useCallback(
    debounce((value) => {
      fetchGroups(value);
    }, 500),
    []
  );

  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await groupService.delete({
        ids: [selectedId],
      });
      setIsDeleteModalOpen(false);
      notify("success", "Group deleted successfully");
      setSelectedId([]);
      fetchGroups();
      setLoading(false);
    } catch (error) {
      console.error("Error deleting group:", error);
      setLoading(false);
    }
  };

  const handleChangeTable = (a, b, c) => {
   const sortColumn = c?.column?.dataIndex;
   const sortOrder = c?.order;

  if (sortColumn && sortOrder) {
    const normalizedOrder = sortOrder === "ascend" ? "asc" : "desc";
    setSortingColumn(`${sortColumn}:${normalizedOrder}`);
  } else {
    setSortingColumn("");
  }
  };

  const groupSpecialty = async () => {
    try {
      setLoading(true);
      const response = await groupService.getGroupSpecialty();
      setAllGroupSpecialty(response?.data?.result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    groupSpecialty();
  }, [allGroupData]);
  

  const hasData = allGroupData.length > 0;
  const scroll = hasData ? { x: "max-content"  } : null;

  return (
    <>
      {isOpen && (
        <AddPhysicianFormModal
          isOpen={isOpen}
          setOpen={setIsOpen}
          fetchPhysician={fetchGroups}
          // selectedId={selectedId}
          selectedPhysicianId={setSelectedId}
          isEdit={isGroupEdit}
          setIsEdit={setIsGroupEdit}
          isGroup={true}
        />
      )}

      {isEditOpen && (
        <AddGroupModal
          isOpen={isEditOpen}
          setIsOpen={setIsEditOpen}
          fetchGroups={fetchGroups}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          isEdit={isGroupEdit}
          setIsEdit={setIsGroupEdit}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteConfirmationModal
          title="Delete Group"
          isOpen={isDeleteModalOpen}
          setOpen={() => setIsDeleteModalOpen(false)}
          onConfiem={handleDelete}
          loading={loading}
        />
      )}

      {physicianDetailModal && (
      <AssisgnedVideoModal isOpen={physicianDetailModal} setOpen={setPhysicianDetailModal} physicianData={physicianData} memberType={memberType} />
      )}

      <PhysicianPageWrapper>
        <Header>
          <div className="row1">
            <div className="heading_text">All Groups</div>
            {/* <CTAButton>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-plus mr-2 h-4 w-4"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>{" "}
            Add Group
          </CTAButton> */}
          </div>
          {/* <div className="row2">
            Manage specialty groups across all hospitals.
          </div> */}
        </Header>

        <ControlsSection>
          <Col
            span={24}
            className="d-flex"
            style={{ justifyContent: "space-between" }}
          >
            <div
              className="d-flex  gap-12"
              style={{ width: "100%", justifyContent: "start" }}
            >
              <CustomSearchContainer>
                <FiSearch
                  style={{ position: "absolute", zIndex: 1 }}
                  className="icon ml-5"
                />
                <Input
                  placeholder="Search here..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    handleSearch(e.target.value);
                  }}
                />
              </CustomSearchContainer>
              <Filter
                show={show}
                setShow={setShow}
                data={[
                  {
                    title: "Specialty",
                    list: allGroupSpecialty,
                    filterList: filterTab,
                    setFilterList: setFilterTab,
                  },
                ]}
              />
            </div>
          </Col>
        </ControlsSection>

        <Col span={24} style={{ flex: 1, padding: "0px", marginTop: "15px" }}>
          <StyledTable
            columns={GroupColumns}
            dataSource={allGroupData}
            loading={loading}
            rowKey="id"
            scroll={scroll}
            pagination={{
              current: pagination?.current,
              pageSize: pagination?.pageSize,
              showSizeChanger: true,
              pageSizeOptions: [25, 50, 100],
              onShowSizeChange: (current, size) => {
                setPagination({
                  ...pagination,
                  current,
                  pageSize: size,
                });
              },
              total: groupCount,
              showTotal: (total, range) =>
                `${range[0]} - ${range[1]} of ${total} groups`,
              showQuickJumper: false,
              showLessItems: true,
              itemRender: (page, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <Button
                      type="text"
                      disabled={pagination?.current === 1}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (pagination?.current > 1) {
                          setPagination((prev) => ({
                            ...prev,
                            current: prev.current - 1,
                          }));
                        }
                      }}
                    >
                      Previous
                    </Button>
                  );
                }
                if (type === "next") {
                  const maxPage = Math.ceil(groupCount / pagination?.pageSize);
                  return (
                    <Button
                      type="text"
                      disabled={pagination?.current === maxPage}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (pagination?.current < maxPage) {
                          setPagination((prev) => ({
                            ...prev,
                            current: prev.current + 1,
                          }));
                        }
                      }}
                    >
                      Next
                    </Button>
                  );
                }
                return originalElement;
              },
            }}
            onChange={handleChangeTable}
          />
        </Col>

        {/* <GroupsGrid /> */}
      </PhysicianPageWrapper>
    </>
  );
};

export default Overview;
